import React from 'react';
import { Space, Title, Text, Checkbox } from 'components';
import { ListingLabelContext } from 'contexts';
import { INotificationSettings } from '@bb/domain/dist/types';

type FridayUpdateProps = {
  weeklyUpdate: INotificationSettings['weeklyUpdate'];
  setModifiedNotifications: React.Dispatch<
    React.SetStateAction<INotificationSettings>
  >;
};

const FridayUpdate: React.FC<FridayUpdateProps> = ({
  weeklyUpdate,
  setModifiedNotifications,
}) => {
  const { getLabel } = React.useContext(ListingLabelContext);

  return (
    <Space direction="vertical" size={'large'}>
      <Space direction="vertical">
        <Title level={3}>Friday Updates</Title>

        <Text>
          You can choose to receive weekly updates on Friday of all coming soon
          listings:
        </Text>
      </Space>
      <Space direction="vertical">
        <Checkbox
          checked={weeklyUpdate}
          data-cy="weekly-update"
          onChange={({ target: { checked } }) =>
            setModifiedNotifications(prev => ({
              ...prev,
              weeklyUpdate: checked,
            }))
          }
        >
          All {getLabel('COMING_SOON')} Listings
        </Checkbox>
      </Space>
    </Space>
  );
};

export default FridayUpdate;
